var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.911 6.72756C13.786 6.55647 10.8059 2.53833 6.99993 2.53833C3.19392 2.53833 0.213774 6.55647 0.08884 6.7274C-0.0296133 6.88971 -0.0296133 7.10986 0.08884 7.27217C0.213774 7.44326 3.19392 11.4614 6.99993 11.4614C10.8059 11.4614 13.786 7.44323 13.911 7.27231C14.0296 7.11002 14.0296 6.88971 13.911 6.72756ZM6.99993 10.5383C4.1964 10.5383 1.76824 7.87141 1.04946 6.99955C1.76731 6.12693 4.19038 3.4614 6.99993 3.4614C9.80333 3.4614 12.2313 6.12786 12.9504 7.00018C12.2326 7.87278 9.80948 10.5383 6.99993 10.5383Z",
    fill: "#344A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00002 4.23096C5.47309 4.23096 4.23077 5.47326 4.23077 7.00019C4.23077 8.52712 5.47309 9.76943 7.00002 9.76943C8.52696 9.76943 9.76928 8.52712 9.76928 7.00019C9.76928 5.47326 8.52696 4.23096 7.00002 4.23096ZM7.00002 8.84633C5.98201 8.84633 5.15388 8.01817 5.15388 7.00019C5.15388 5.98221 5.98204 5.15405 7.00002 5.15405C8.01801 5.15405 8.84617 5.98221 8.84617 7.00019C8.84617 8.01817 8.01804 8.84633 7.00002 8.84633Z",
    fill: "#344A3D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeView);
export default __webpack_public_path__ + "static/media/eye-view.ce75b3abae1ec7337fa7ec3e5c497c14.svg";
export { ForwardRef as ReactComponent };